
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "TPCOR",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/TPCOR.vue